import axios, { type AxiosInstance } from 'axios';
import type { ApiErrorBody } from '@s-blog/shared-types';

// 前台只调公开接口（/api/public/* + /api/site-config GET + /api/search），
// 不需要 cookie / refresh / 401 重试，比 admin 的 http.ts 简化很多。
export const http: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  timeout: 20_000,
});

export function apiErrorMessage(err: unknown, fallback = '请求失败'): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as ApiErrorBody | undefined;
    return body?.message ?? err.message ?? fallback;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
